<template>
  <iframe
    id="form-iframe"
    :src="src"
    frameborder="0"
    height="100%"
    width="100%"
  ></iframe>
</template>

<script>
export default {
  name: "FormLinkRender",
  props: {
    src: { type: String, default: null },
  },
};
</script>

<style>
#form-iframe {
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
</style>
